var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgZoomIn = function SvgZoomIn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 10.5h12v3h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 6h12v3h-12z",
    transform: "matrix(0 1 -1 0 19.5 -7.5)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZoomIn);
export default ForwardRef;